import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'busy-indicator',
  templateUrl: './busy-indicator.component.html',
  styleUrls: ['./busy-indicator.component.scss']
})
export class BusyIndicatorComponent implements OnInit {
  @Input() diameter: number = 200;
  
  constructor() { }

  ngOnInit() {
  }

}